import { createAction } from '@reduxjs/toolkit';

export const SetNotificationListAction = createAction<INotification[]>('shell/SetNotificationListAction');

export const UpdateNotificationListAction = createAction<INotification>('shell/UpdateNotificationListAction');
